import { fetchWithAuth } from '../../../../js/authToken';
import API_BASE_URL from '../../../../js/urlHelper';
import { toast } from 'react-toastify';

const AsesoresCard = ({ asesor, onStatusChange, onEdit }) => {
  const contactoPrincipal = asesor.datos?.contactos?.find((c) => c.tipo === 'PRINCIPAL') || {};
  const direccionFiscal = asesor.datos?.direcciones?.find((d) => d.tipo === 'FISCAL') || {};
  const direccionCorrespondencia = asesor.datos?.direcciones?.find((d) => d.tipo === 'CORRESPONDENCIA') || {};
  const cuentaBancaria = asesor.datos?.cuentas_bancarias?.[0] || {};

  const toggleEstado = async () => {
    try {
      const newStatus = asesor.estado === 1 ? 0 : 1;

      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/admin/asesores/${asesor.idUsuario}/status`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ estado: newStatus ? 'activo' : 'inactivo' }),
        }
      );

      if (response.ok) {
        if (onStatusChange) {
          onStatusChange(asesor.idUsuario, newStatus);
        }
        toast.success('Estado actualizado correctamente');
      } else {
        toast.error('Error al cambiar estado del asesor');
      }
    } catch (error) {
      toast.error('Error de conexión al servidor');
    }
  };

  const handleEdit = () => {
    if (onEdit) {
      onEdit(asesor);
    }
  };

  const formatDireccion = (direccion) => {
    if (!direccion || Object.keys(direccion).length === 0) return 'No registrada';

    const partes = [];
    if (direccion.tipoVia) partes.push(direccion.tipoVia);
    if (direccion.nombreVia) partes.push(direccion.nombreVia);
    if (direccion.numeroMz) partes.push(direccion.numeroMz);
    if (direccion.urbanizacion) partes.push(direccion.urbanizacion);

    const ubicacion = [direccion.distrito, direccion.provincia, direccion.departamento]
      .filter(Boolean)
      .map((val) => val.replace(/_/g, ' '))
      .join(', ');

    let resultado = partes.join(' ');
    if (ubicacion) resultado += (resultado ? ', ' : '') + ubicacion;

    return resultado.trim() || 'No registrada';
  };

  return (
    <div className="ui-card relative overflow-hidden transition-shadow duration-200 hover:shadow-md">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1.5 bg-red-600" />

      <div className="relative p-4 sm:p-5">
        <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h3 className="text-lg font-semibold text-red-800">
              {asesor.datos?.nombre || ''} {asesor.datos?.apellidoPaterno || ''} {asesor.datos?.apellidoMaterno || ''} {asesor.datos?.apellidoConyuge || ''}
            </h3>
            <p className="text-xs font-medium uppercase tracking-[0.08em] text-slate-500">
              {asesor.datos?.estadoCivil || 'No registrado'}
            </p>
          </div>

          <div className="flex items-center self-start sm:self-auto">
            <span
              className={`rounded-full px-3 py-1 text-sm font-semibold ${
                asesor.estado === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}
            >
              {asesor.estado === 1 ? 'Activo' : 'Inactivo'}
            </span>
            <button
              onClick={toggleEstado}
              className="ml-3 text-slate-500 transition hover:text-slate-700"
              title={asesor.estado === 1 ? 'Desactivar asesor' : 'Activar asesor'}
            >
              {asesor.estado === 1 ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500 hover:text-red-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 hover:text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              )}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 text-sm">
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
              <p className="text-xs text-slate-500">DNI/CARNET:</p>
              <p className="font-medium">{asesor.datos?.dni || 'No registrado'}</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
              <p className="text-xs text-slate-500">TELÉFONO:</p>
              <p className="font-medium">{contactoPrincipal?.telefono || 'No registrado'}</p>
            </div>
          </div>

          <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
            <p className="text-xs text-slate-500">E-MAIL:</p>
            <p className="truncate font-medium">{contactoPrincipal?.email || 'No registrado'}</p>
          </div>

          <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
            <p className="text-xs text-slate-500">DIRECCIÓN FISCAL:</p>
            <p className="truncate font-medium">{formatDireccion(direccionFiscal)}</p>
          </div>

          <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
            <p className="text-xs text-slate-500">DIRECCIÓN DE CORRESPONDENCIA:</p>
            <p className="truncate font-medium">{formatDireccion(direccionCorrespondencia)}</p>
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
              <p className="text-xs text-slate-500">N° CUENTA:</p>
              <p className="font-medium">{cuentaBancaria.numeroCuenta || 'No registrada'}</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
              <p className="text-xs text-slate-500">CCI:</p>
              <p className="font-medium">{cuentaBancaria.cci || 'No registrada'}</p>
            </div>
          </div>

          <div className="rounded-lg border border-slate-200 bg-slate-50 p-2">
            <p className="text-xs text-slate-500">ENTIDAD FINANCIERA:</p>
            <p className="font-medium">{cuentaBancaria.entidadFinanciera || 'No registrada'}</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between border-t border-slate-200 bg-slate-100 px-4 py-3 text-sm">
        <span className="text-xs text-slate-500">ID: {asesor.idUsuario}</span>
        <button
          onClick={handleEdit}
          className="inline-flex items-center rounded-lg bg-slate-700 px-4 py-1.5 font-medium text-white transition hover:bg-slate-800"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="mr-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
          Editar
        </button>
      </div>
    </div>
  );
};

export default AsesoresCard;
